module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.5105/img/storefront-header-blobs.svg"